__turbopack_context__.v({
  "modalBody": "LocationPermissionModal-module-scss-module__z_E0lq__modalBody",
  "modalFooter": "LocationPermissionModal-module-scss-module__z_E0lq__modalFooter",
});
